import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { Box } from "@material-ui/core";
import { Info } from "@mui/icons-material";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import { Loader } from "components/Loader";
import { checkEditorPermission } from "services/utils/HelperFunction";
import moment from "moment";
import { customGetAPI } from "services/utils/CustomAPI";
import {
  CustomButton,
  InfoMessage,
} from "components/CustomComponents/CustomButton";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { useSelector } from "react-redux";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { AssignWorkUnit } from "./AssignWorkUint";
import { formKeyText } from "services/constants/Styles";
import DateRangePicker from "react-bootstrap-daterangepicker";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { showToast } from "services/utils/Status";
import { CustomButtonWithOutLoader } from "components/CustomComponents/CustomButton";
import { tooltipStyleProps } from "services/constants/Styles";

export const Weekly = ({
  loading,
  weeklyShiftList,
  listOfDate,
  filterChanges,
  setFilterChanges,
  updateWeeklyShift,
  setFetchWeekly,
  shiftGrpError,
  setGrpNameError,
  departmentIdValue,
  workUnitCheck,
  departmentNames,
  masterDataForSearch,
}) => {
  const [page, setLeavePage] = useState(0);
  const [rowsPerPage, setLeaveRowsPerPage] = useState(25);
  const handleChangePage = (event, newPage) => {
    setLeavePage(newPage);
  };
  const { domain, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [userShiftsDet, setUserShiftsDet] = useState([]);
  const [curShiftDetail, setCurShiftDetail] = useState([]);
  const [shiftName, setShiftName] = useState("");
  const [shiftId, setShiftId] = useState("");
  const [editWorkUnitDialogBox, setOpenEditWorkUnitDialogBox] = useState(false);
  const [shiftGrpData, setSftGrpData] = useState([]);
  const [triggerApi, setTriggerApi] = useState(false);
  const [getSftDate, setgetSftDate] = useState("");
  const dateStr = getSftDate;
  const [day, month, year] = dateStr.split("-");
  const formattedDate = `${year}-${month}-${day}`;
  const [weeklyScreen, setWeeklyScreen] = useState(false);
  const [calculateInnerWidth, setCalculateInnerWidth] = useState(
    window.innerWidth < 1400
  );
  const [getDepartmentId, setGetDepartmentId] = useState("");
  const containerRef = useRef(null);
  const [shiftBased, setShiftBased] = useState(
    departmentNames === "All" ? "All Department" : "Current Department"
  );
  const [selectedDates, setSelectedDates] = useState([]);
  const [latestPayDate, setLatestPayDate] = useState("");
  const [disable, setDisable] = useState(true);

  useEffect(() => {
    setShiftBased(
      departmentNames === "All" ? "All Department" : "Current Department"
    );
  }, [departmentNames]);

  const [state, setState] = useState(() => {
    const formattedLatestPayDate = moment(latestPayDate, "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    );
    const index = listOfDate.indexOf(formattedLatestPayDate);

    const startDate =
      index !== -1 && index + 1 < listOfDate.length
        ? moment(listOfDate[index + 1])
        : moment(listOfDate[0]);

    const endDate = moment(listOfDate[listOfDate.length - 1]);

    return {
      start: startDate,
      end: endDate,
    };
  });

  useEffect(() => {
    const formattedLatestPayDate = moment(latestPayDate, "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    );
    const index = listOfDate.indexOf(formattedLatestPayDate);

    const startDate =
      index !== -1 && index + 1 < listOfDate.length
        ? moment(listOfDate[index + 1])
        : moment(listOfDate[0]);

    const endDate = moment(listOfDate[listOfDate.length - 1]);
    setState({
      start: startDate,
      end: endDate,
    });
    if (index !== -1 && index + 1 < listOfDate.length) {
      setSelectedDates(listOfDate.slice(index + 1));
    } else {
      setSelectedDates(listOfDate);
    }
  }, [latestPayDate, listOfDate]);

  useEffect(() => {
    const handleResize = () => {
      setCalculateInnerWidth(window.innerWidth < 1400);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { start, end } = state;
  const handleCallback = (start, end) => {
    setState({ start, end });

    const dates = [];
    const currentDate = moment(start);

    while (currentDate.isSameOrBefore(end, "day")) {
      dates.push(currentDate.format("YYYY-MM-DD"));
      currentDate.add(1, "day");
    }
    setSelectedDates(dates);
    setShiftName("");
    setDisable(false);
  };

  const label = start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
  const sortedWeeklyShiftList = weeklyShiftList?.sort((a, b) => {
    const assignNameA = a.user_name || "";
    const assignNameB = b.user_name || "";
    return assignNameA.localeCompare(assignNameB, undefined, {
      numeric: true,
    });
  });

  const handleChangeRowsPerPage = (event) => {
    setLeaveRowsPerPage(parseInt(event.target.value, 10));
    setLeavePage(0);
  };
  useEffect(() => {
    if (filterChanges) {
      setFilterChanges(false);
      setLeavePage(0);
    }
  }, [filterChanges, setFilterChanges]);

  const hasDatesBeforeLatestPayDate = selectedDates.some((date) =>
    moment(date).isBefore(moment(latestPayDate, "DD-MM-YYYY"), "day")
  );

  const updateIndividualShift = async () => {
    const shift_assignments = selectedDates.map((date) => ({
      shift_id: shiftId ?? curShiftDetail?.shift_id,
      date: date,
      is_week_off: shiftName === "Weekoff",
      unassigned: curShiftDetail?.shift_name === "Unassigned",
    }));
    if (shiftName !== "" && !hasDatesBeforeLatestPayDate) {
      updateWeeklyShift(userShiftsDet?.user_id, shift_assignments);
      setOpenDialog(false);
      setShiftBased(
        departmentNames === "All" ? "All Department" : "Current Department"
      );
      const startDate = moment(listOfDate[0]);
      const endDate = moment(listOfDate[listOfDate.length - 1]);
      setState({ start: startDate, end: endDate });
      setSelectedDates(listOfDate);
    } else if (shiftName === "") {
      setGrpNameError(true);
    } else {
      showToast("error", "Selected detes must after previous payrun date");
    }
  };

  const handleShiftGroup = (event, data) => {
    if (data) {
      setShiftName(data?.label);
      setShiftId(data?.shift_id);
      setDisable(false);
    } else {
      setShiftName("");
      setShiftId("");
    }
  };

  useEffect(() => {
    const fetchIndividualUserDetails = async () => {
      const url =
        shiftBased === "Current Department"
          ? `${domain}deparment-shift-filter/?department_id=${
              shiftBased === "Current Department"
                ? getDepartmentId
                : departmentIdValue
            }&date=${formattedDate}`
          : `${domain}all/shift-filter/`;
      const res = await customGetAPI(url);
      if (res.ok) {
        setSftGrpData(res?.responseDetails);
      }
    };
    if (triggerApi) {
      fetchIndividualUserDetails();
      setTriggerApi(false);
    }
  }, [
    departmentIdValue,
    domain,
    formattedDate,
    getDepartmentId,
    shiftBased,
    triggerApi,
    userShiftsDet.user_id,
  ]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const selectShiftBased = (event) => {
    setShiftBased(event.target.value);
    setTriggerApi(true);
    setGrpNameError(false);
    setDisable(false);
  };

  return (
    <React.Fragment>
      {loading ? (
        <Box>
          <Loader info="Loading..." />
        </Box>
      ) : (
        <>
          <Mui.Grid container>
            <Mui.TableContainer
              ref={containerRef}
              component={Mui.Paper}
              sx={{
                mt: 2,
                width: "100%",
                border: 1,
                borderRadius: 5,
                borderColor: themes.primary,
                maxHeight: calculateInnerWidth ? 380 : 690,
                ml: 1,
                mr: 1,
              }}
            >
              <Mui.Table>
                <Mui.TableHead
                  sx={{
                    backgroundColor: themes.primary,
                    position: "sticky",
                    top: -1,
                    zIndex: 10,
                  }}
                >
                  <Mui.TableRow>
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                      }}
                    >
                      Employee Name
                    </Mui.TableCell>

                    {listOfDate?.map((value) => (
                      <Mui.TableCell>
                        <Mui.Stack
                          direction="column"
                          sx={{
                            alignItems: "center",
                          }}
                        >
                          <Mui.Typography
                            sx={{
                              color: themes.headLine,
                              fontWeight: "bold",
                              fontSize: 24,
                            }}
                          >
                            {moment(value, "YYYY-MM-DD").format("DD")}
                          </Mui.Typography>
                          <Mui.Typography
                            sx={{
                              color: themes.headLine,
                              fontWeight: "bold",
                              fontSize: 12,
                            }}
                          >
                            {moment(value, "YYYY-MM-DD").format("ddd, MMM")}
                          </Mui.Typography>
                        </Mui.Stack>
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {sortedWeeklyShiftList?.length === 0 ? (
                    <InfoMessage dataLength={masterDataForSearch} />
                  ) : (
                    sortedWeeklyShiftList
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((shiftList, index) => (
                        <React.Fragment>
                          <Mui.TableRow key={index} sx={{ cursor: "pointer" }}>
                            <Mui.TableCell
                              sx={{ border: 1, borderColor: themes.primary }}
                            >
                              <Mui.Stack direction="Row">
                                <Mui.Avatar
                                  sx={{ width: 23, height: 23 }}
                                  alt={shiftList?.user_name
                                    ?.charAt(0)
                                    .toUpperCase()}
                                  src={shiftList?.image_url ?? optionalAvathar}
                                />
                                <Mui.Typography
                                  sx={{
                                    paddingLeft: 1,
                                  }}
                                >
                                  {shiftList.user_name}
                                </Mui.Typography>
                              </Mui.Stack>
                            </Mui.TableCell>
                            {shiftList?.shifts.map((shift, i) => (
                              <Mui.TableCell
                                sx={{
                                  fontSize: 13,
                                  border: 1,
                                  borderColor: themes.primary,
                                  backgroundColor: shift?.color_code,
                                }}
                              >
                                <Mui.Grid container>
                                  <Mui.Grid
                                    xs={
                                      shift?.default_units?.total_count ||
                                      shift?.additional_units?.total_count
                                        ? departmentNames === "All"
                                          ? 12
                                          : 8
                                        : 12
                                    }
                                    sx={{
                                      borderRight:
                                        shift?.default_units?.total_count ||
                                        shift?.additional_units?.total_count
                                          ? departmentNames === "All"
                                            ? "none"
                                            : `3px solid ${themes.sidebarDivider}`
                                          : "none",
                                    }}
                                    onClick={() => {
                                      if (
                                        checkEditorPermission(
                                          userScreenAccess?.module_details,
                                          "Shift",
                                          "Shift"
                                        )
                                      ) {
                                        setUserShiftsDet(shiftList);
                                        setgetSftDate(shift?.date);
                                        setCurShiftDetail(shift);
                                        setLatestPayDate(
                                          shiftList?.latest_pay_date
                                        );
                                        setGetDepartmentId(
                                          shiftList?.department_id
                                        );
                                        setShiftName(
                                          shift?.shift_name === "Unassigned"
                                            ? ""
                                            : shift?.shift_name
                                        );
                                        setShiftId(shift?.shift_id);
                                        setOpenDialog(true);
                                        setTriggerApi(true);
                                      } else {
                                        showToast(
                                          "error",
                                          "Access denied: You are not authorized to change shift"
                                        );
                                      }
                                    }}
                                  >
                                    <Mui.Stack
                                      direction="column"
                                      width={"100%"}
                                      sx={{
                                        alignItems: "center",
                                      }}
                                    >
                                      <Mui.Typography
                                        sx={{
                                          fontSize: 12,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {shift?.shift_name
                                          ? shift?.shift_name
                                          : "Not Joined"}
                                      </Mui.Typography>
                                      {shift?.shift_name === null ||
                                      shift?.shift_name === "Weekoff" ? (
                                        ""
                                      ) : shift?.shift_start_time &&
                                        shift?.shift_end_time ? (
                                        <>
                                          <Mui.Typography sx={{ fontSize: 12 }}>
                                            {moment(
                                              shift?.shift_start_time,
                                              "HH:mm:SS"
                                            ).format("h:mm a")}
                                            {" to "}{" "}
                                            {moment(
                                              shift?.shift_end_time,
                                              "HH:mm:SS"
                                            ).format("h:mm a")}
                                          </Mui.Typography>
                                        </>
                                      ) : null}
                                    </Mui.Stack>
                                  </Mui.Grid>
                                  {workUnitCheck &&
                                  (shift?.default_units?.total_count ||
                                    shift?.additional_units?.total_count) ? (
                                    <Mui.Grid
                                      xs={
                                        shift?.default_units?.total_count
                                          ? 4
                                          : 0
                                      }
                                      sx={{ alignItems: "center" }}
                                      onClick={() => {
                                        setOpenEditWorkUnitDialogBox(true);
                                        setUserShiftsDet(shiftList);
                                        setCurShiftDetail(shift);
                                        setShiftName(shift?.shift_name);
                                        setShiftId(shift?.shift_id);
                                        setWeeklyScreen(true);
                                      }}
                                    >
                                      <Mui.Stack>
                                        <Mui.Typography
                                          sx={{
                                            fontWeight: "bold",
                                            textAlign: "center",
                                          }}
                                        >
                                          Unit
                                        </Mui.Typography>
                                        <Mui.Typography
                                          sx={{
                                            textAlign: "center",
                                            fontSize: {
                                              xs: 12,
                                              sm: 12,
                                              md: 15,
                                              lg: 15,
                                            },
                                          }}
                                        >
                                          <Mui.Tooltip
                                            arrow
                                            slotProps={tooltipStyleProps}
                                            title={
                                              <>
                                                <Mui.Typography>
                                                  Default Work Unit
                                                </Mui.Typography>
                                                {shift?.default_units?.details?.map(
                                                  (data) => (
                                                    <Mui.Grid
                                                      container
                                                      sx={{
                                                        borderTop: `2px solid ${themes.sidebarDivider}`,
                                                        borderBottom: `2px solid ${themes.sidebarDivider}`,
                                                      }}
                                                    >
                                                      <Mui.Grid xs={6}>
                                                        <Mui.Typography>
                                                          {data?.work_unit_name}
                                                        </Mui.Typography>
                                                      </Mui.Grid>
                                                      <Mui.Grid xs={6}>
                                                        <Mui.Typography>
                                                          {
                                                            data?.number_of_units
                                                          }
                                                        </Mui.Typography>
                                                      </Mui.Grid>
                                                    </Mui.Grid>
                                                  )
                                                )}
                                              </>
                                            }
                                          >
                                            {shift?.default_units?.total_count
                                              ? shift?.default_units
                                                  ?.total_count
                                              : 0}
                                            {" + "}
                                          </Mui.Tooltip>

                                          <Mui.Tooltip
                                            arrow
                                            slotProps={tooltipStyleProps}
                                            title={
                                              <>
                                                <Mui.Typography>
                                                  Additional Work Unit
                                                </Mui.Typography>
                                                {shift?.additional_units?.details?.map(
                                                  (data) => (
                                                    <Mui.Grid
                                                      container
                                                      sx={{
                                                        borderTop: `2px solid ${themes.sidebarDivider}`,
                                                        borderBottom: `2px solid ${themes.sidebarDivider}`,
                                                      }}
                                                    >
                                                      <Mui.Grid xs={6}>
                                                        <Mui.Typography>
                                                          {data?.work_unit_name}
                                                        </Mui.Typography>
                                                      </Mui.Grid>
                                                      <Mui.Grid xs={6}>
                                                        <Mui.Typography>
                                                          {
                                                            data?.number_of_units
                                                          }
                                                        </Mui.Typography>
                                                      </Mui.Grid>
                                                    </Mui.Grid>
                                                  )
                                                )}
                                              </>
                                            }
                                          >
                                            {shift?.additional_units
                                              ?.total_count
                                              ? shift?.additional_units
                                                  ?.total_count
                                              : 0}
                                          </Mui.Tooltip>
                                        </Mui.Typography>
                                      </Mui.Stack>
                                    </Mui.Grid>
                                  ) : null}
                                </Mui.Grid>
                              </Mui.TableCell>
                            ))}
                          </Mui.TableRow>
                        </React.Fragment>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
          </Mui.Grid>
          {sortedWeeklyShiftList.length > 25 && (
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={sortedWeeklyShiftList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
          {openDialog ? (
            <div>
              <GlobalDialogBox
                handleCloseDialog={() => {
                  setOpenDialog(false);
                  setGrpNameError(false);
                  setDisable(true);
                  setShiftBased(
                    departmentNames === "All"
                      ? "All Department"
                      : "Current Department"
                  );
                  const startDate = moment(listOfDate[0]);
                  const endDate = moment(listOfDate[listOfDate.length - 1]);
                  setState({ start: startDate, end: endDate });
                  setSelectedDates(listOfDate);
                }}
                minWidth={800}
                open={openDialog}
                title="Edit Shift Details"
              >
                <Mui.Grid container>
                  <Mui.Grid container>
                    <Mui.Grid item xs={5.5}>
                      <Mui.Typography sx={formKeyText}>
                        Employee Name &nbsp;{" "}
                        <Mui.Tooltip
                          arrow
                          slotProps={tooltipStyleProps}
                          title="Displays the name of the employee whose shift details are being modified."
                        >
                          <Info />
                        </Mui.Tooltip>
                      </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item xs={6}>
                      <Mui.Typography
                        sx={{ fontWeight: 700, fontSize: 18, mt: 1.7 }}
                      >
                        {userShiftsDet?.user_name}
                      </Mui.Typography>
                    </Mui.Grid>
                  </Mui.Grid>
                  <Mui.Grid container sx={{ mt: 1.5 }}>
                    <Mui.Grid item xs={5.5}>
                      <Mui.Typography sx={formKeyText}>
                        Date&nbsp;{" "}
                        <Mui.Tooltip
                          arrow
                          slotProps={tooltipStyleProps}
                          title="Select a 7-day range to apply shift changes across the entire week."
                        >
                          <Info />
                        </Mui.Tooltip>
                      </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item xs={6} sx={{ mt: 0.6 }}>
                      <DateRangePicker
                        initialSettings={{
                          startDate: start.toDate(),
                          endDate: end.toDate(),

                          applyClass: "custom-apply-btn",
                          cancelClass: "custom-cancel-btn",
                          minDate: latestPayDate
                            ? moment(latestPayDate, "DD-MM-YYYY")
                                .add(1, "day")
                                .toDate()
                            : false,
                          locale: {
                            format: "DD/MM/YYYY",
                          },
                          // isInvalidDate: (date) => {
                          //   const formatted = date.format("YYYY-MM-DD");
                          //   return !selectedDates.includes(formatted);
                          // },
                        }}
                        onCallback={handleCallback}
                      >
                        <Mui.TextField
                          id="reportrange"
                          variant="outlined"
                          label=""
                          placeholder="Select a date range"
                          value={label}
                          size="small"
                          InputProps={{
                            readOnly: true,
                            notched: false,
                            endAdornment: (
                              <Mui.InputAdornment position="end">
                                <Mui.IconButton>
                                  <DateRangeIcon />
                                </Mui.IconButton>
                              </Mui.InputAdornment>
                            ),
                          }}
                          InputLabelProps={{ shrink: true, required: true }}
                          fullWidth
                          sx={{
                            "& .MuiOutlinedInput-notchedOutline": {
                              legend: {
                                display: "none",
                              },
                            },
                          }}
                        />
                      </DateRangePicker>
                    </Mui.Grid>
                  </Mui.Grid>
                  <Mui.Grid container sx={{ mt: 1.5 }}>
                    <Mui.Grid item xs={5.5}>
                      <Mui.Typography sx={formKeyText}>
                        {" "}
                        Shift based on &nbsp;{" "}
                        <Mui.Tooltip
                          arrow
                          slotProps={tooltipStyleProps}
                          title="Choose whether to view shift options based on the employee’s current department or across all departments."
                        >
                          <Info />
                        </Mui.Tooltip>
                      </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid xs={6} container sx={{ mt: 0.5 }}>
                      <Mui.RadioGroup
                        row
                        onChange={selectShiftBased}
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={shiftBased}
                        name="radio-buttons-group"
                      >
                        <Mui.FormControlLabel
                          label="Current Department"
                          value="Current Department"
                          control={<Mui.Radio />}
                        />

                        <Mui.FormControlLabel
                          label="All Department"
                          value="All Department"
                          control={<Mui.Radio />}
                        />
                      </Mui.RadioGroup>
                    </Mui.Grid>
                  </Mui.Grid>

                  <Mui.Grid container sx={{ mt: 1.5 }}>
                    <Mui.Grid item xs={5.5}>
                      <Mui.Typography sx={formKeyText}>
                        Shift Name&nbsp;{" "}
                        <Mui.Tooltip
                          arrow
                          slotProps={tooltipStyleProps}
                          title="Select the appropriate shift to assign for the chosen date."
                        >
                          <Info />
                        </Mui.Tooltip>
                      </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item xs={6} sx={{ mt: 0.5 }}>
                      <CustomAutoComplete
                        dataList={shiftGrpData
                          ?.filter((obj) => obj?.shift_name !== shiftName)
                          .map((obj) => ({
                            ...obj,
                            label: obj?.shift_name,
                          }))}
                        selectedValue={shiftName}
                        updateDataFunction={handleShiftGroup}
                        placeHolder="Select shift group name"
                      />
                      {shiftGrpError ? (
                        <h6
                          style={{
                            paddingTop: 2,
                            color: themes.helperTextColor,
                            fontSize: 12,
                          }}
                        >
                          Shift name is required
                        </h6>
                      ) : null}
                    </Mui.Grid>
                  </Mui.Grid>

                  <Mui.Grid container sx={{ mt: 1 }}>
                    <Mui.Grid xs={8.9}></Mui.Grid>
                    <Mui.Grid xs={3}>
                      <CustomButton
                        actionFuntion={() => {
                          setOpenDialog(false);
                          setGrpNameError(false);
                          setDisable(true);
                          setShiftBased(
                            departmentNames === "All"
                              ? "All Department"
                              : "Current Department"
                          );
                          const startDate = moment(listOfDate[0]);
                          const endDate = moment(
                            listOfDate[listOfDate.length - 1]
                          );
                          setState({ start: startDate, end: endDate });
                          setSelectedDates(listOfDate);
                        }}
                        actionName="Cancel"
                        typeName="button"
                      />
                      &nbsp;
                      <CustomButtonWithOutLoader
                        actionName="Update"
                        typeName="submit"
                        actionFuntion={updateIndividualShift}
                        disableAction={disable}
                      />
                    </Mui.Grid>
                  </Mui.Grid>
                </Mui.Grid>
              </GlobalDialogBox>
            </div>
          ) : null}
        </>
      )}

      {editWorkUnitDialogBox ? (
        <AssignWorkUnit
          userShiftsDet={userShiftsDet}
          curShiftDetail={curShiftDetail}
          shiftName={shiftName}
          setOpenEditWorkUnitDialogBox={setOpenEditWorkUnitDialogBox}
          editWorkUnitDialogBox={editWorkUnitDialogBox}
          setFetchWeekly={setFetchWeekly}
          setWeeklyScreen={setWeeklyScreen}
          weeklyScreen={weeklyScreen}
        />
      ) : null}
    </React.Fragment>
  );
};
